import { useT } from "./i18n";
import appIcon from "./app-icon.jpg";

export function HomePage() {
  const t = useT();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6">
      {/* Hero */}
      <div className="text-center max-w-lg">
        {/* App Icon */}
        <img
          src={appIcon}
          alt="Joker Gambit"
          className="w-28 h-28 mx-auto mb-8 rounded-[28px] shadow-lg"
        />

        <h1 className="text-4xl font-bold tracking-tight mb-3">Joker Gambit</h1>
        <p className="text-[var(--color-text-muted)] text-lg leading-relaxed mb-2">
          {t("homeSubtitle")}
        </p>
        <p className="text-[var(--color-text-muted)] text-base leading-relaxed mb-10 whitespace-pre-line">
          {t("homeDesc")}
        </p>

        {/* App Store Button */}
        <a
          href="https://apps.apple.com/app/joker-gambit/id0000000000"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block no-underline hover:no-underline"
        >
          <img
            src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
            alt="Download on the App Store"
            className="h-14 hover:opacity-80 transition-opacity"
          />
        </a>
      </div>

      {/* Footer */}
      <footer className="absolute bottom-8 text-sm text-[var(--color-text-muted)] flex gap-4">
        <a href="/privacy" className="hover:text-[var(--color-text)]">{t("privacy")}</a>
        <span>·</span>
        <a href="/terms" className="hover:text-[var(--color-text)]">{t("terms")}</a>
      </footer>
    </div>
  );
}
